exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-list-item__video-list-item__1CKII{position:relative;margin-right:10px;margin-bottom:10px}.video-list-item__video-list-item__1CKII.video-list-item__is-last__2KzKB{margin-right:0}", ""]);

// exports
exports.locals = {
	"video-list-item": "video-list-item__video-list-item__1CKII",
	"videoListItem": "video-list-item__video-list-item__1CKII",
	"is-last": "video-list-item__is-last__2KzKB",
	"isLast": "video-list-item__is-last__2KzKB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/views/desktop/classic/components/videos/video-list-item/video-list-item.styl
// module id = 2933
// module chunks = 1